import { render, staticRenderFns } from "./plattask.vue?vue&type=template&id=3f0546a6&"
import script from "./plattask.vue?vue&type=script&lang=js&"
export * from "./plattask.vue?vue&type=script&lang=js&"
import style0 from "./plattask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports